import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronLeft, ChevronRight, ExitToApp, Lock, QuestionAnswer } from '@material-ui/icons';
import {
  Typography,
  Icon,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
  Divider,
} from '@material-ui/core';
import clsx from 'clsx';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { Icons } from 'components';
import { DataHeader } from './DataHeader';
import useWidth from 'hooks/useWidth';
import MenuMobile from './MenuMobile';
import SubSellerSelect from './SubSellerSelect';
import breadcrumbsFunc from './breadcrumbs-function';
import { routes } from 'utils/routers.constants';

import { history } from 'store/store-config';
import { logout } from 'store/reducers/auth.reducer';
import { changeSubSeller } from 'store/reducers/user.reducer';

import { StyledMenu, StyledMenuItem } from "./styles/customMenu";
import { useStylesHeader } from "./styles/styles";
import { whatsApp } from 'utils/env.constants';

export const managementItemId = 13;

  const handleRedirectToFAQ = () => {
    const url = { pathname: "/support", search: "?tab=faq" };

    if (history.location.pathname.startsWith("/support")) {
      history.replace(url);
    } else {
      history.push(url);
    }
  };

const Header = ({ children, currentRoute }) => {
  const dispatch = useDispatch();
  const classes = useStylesHeader();
  const displayWidth = useWidth();
  const theme = useTheme();
  const { pathname } = useLocation();
  const definedWidth = 820;

  const user = useSelector(({ User }) => User);

  const [open, setOpen] = useState(false);
  const [, setBreadcrumbs] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    const items = breadcrumbsFunc(currentRoute);
    setBreadcrumbs(items);
  }, [currentRoute]);

  const handleLogout = () => {
    dispatch(logout());
  }

  const handleLinkRouter = useCallback((router) => {
    history.push(router);
  }, []);

  const handleDrawerOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleChangePassword = useCallback(() => {
    history.push(routes.CHANGE_PASSWORD);
    handleClose();
  }, [handleClose]);

  const handleChangeSubSeller = subsellerId => {
    dispatch(changeSubSeller(subsellerId));
  };

  const newDateHeader = DataHeader.map((item) => {
    if(user.admin) {
      return {
        ...item,
        permission: true
      }
    }

    if(item.hasReconciliation && user.manageReconciliation) {
      return {
        ...item,
        permission: true
      }
    }

    return item
  })

  return (
    <>
      {displayWidth > definedWidth ? (
        <>
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar>
              <div className={clsx(classes.logoClose, { [classes.hide]: open })}>
                <Icons name='icon-cispay' color="#00619E" width={35} height={35} />
              </div>

              <button type="button" className={clsx(classes.buttonOpenMenu, {
                [classes.hide]: open,
              })} onClick={handleDrawerOpen}>
                <ChevronRight />
              </button>

              <section className={clsx(classes.header_top, { [classes.leftSpace]: open })}>
                <SubSellerSelect
                  color='primary'
                  onChange={handleChangeSubSeller}
                />

                <section className={classes.content_logout}>
                  <Typography variant='subtitle1' component='span' className={classes.nickname}>
                    {user.superAdmin ? `${user.name} (super admin)` : user.name}
                  </Typography>
                  <>
                    <IconButton size="medium" onClick={handleClick}>
                      <Icon className={classes.icon_more}>keyboard_arrow_down</Icon>
                    </IconButton>

                    <StyledMenu
                      id="customized-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <StyledMenuItem onClick={handleChangePassword}>
                        <ListItemIcon >
                          <Lock fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Trocar senha" />
                      </StyledMenuItem>
                      <StyledMenuItem onClick={handleLogout}>
                        <ListItemIcon>
                          <ExitToApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Sair" />
                      </StyledMenuItem>
                    </StyledMenu>
                  </>
                  <Divider className={classes.headerDivider} />
                  <WhatsAppButton />
                  <Tooltip title='FAQ'>
                    <IconButton size="medium" onClick={handleRedirectToFAQ}>
                    <QuestionAnswer className={classes.faqIcon}/>
                    </IconButton>
                  </Tooltip>
                </section>
              </section>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              }),
            }}
          >
            <div className={classes.toolbar}>
              <Icons name='icon-logo-cispay' color="#00619E" width={100} height={40} />
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
              </IconButton>
            </div>
            <List>
              {newDateHeader.filter((item) => item.permission).map((item) => {
                return (
                  <div key={item.id}>
                    {item.id === managementItemId && <Divider className={classes.divider} />}
                    <Tooltip key={item.id} title={item.title} placement="right">
                      <ListItem button onClick={() => handleLinkRouter(item.router)} >
                        <ListItemIcon>
                          <Icon
                            className={classes.icon_router}
                            style={{ color: pathname === item.router ? '#00619E' : '#bbc3cc' }}
                          >
                            {item.icon}
                          </Icon>
                        </ListItemIcon>
                        <ListItemText primary={item.title} style={{ color: pathname === item.router ? '#00619E' : '#bbc3cc' }} />
                      </ListItem>
                    </Tooltip>
                  </div>
                )
              })}
            </List>
          </Drawer>
        </>
      ) : (
          <>
            <AppBar position="fixed" color='primary'>
              <Toolbar style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                <MenuMobile
                  Items={newDateHeader.filter(item => item.permission)}
                  onLinkRouter={handleLinkRouter}
                  onLogout={handleLogout}
                />
                <SubSellerSelect
                  subsellers={user.subsellers}
                  selected={user.subsellerId}
                  onChange={handleChangeSubSeller}
                />
                <Icons name='icon-cispay' width={34} height={34} />
              </Toolbar>
            </AppBar>
          </>
        )
      }
        <div className={clsx(classes.container, { [classes.containerOpen]: open })}>
          {children}
        </div>
    </>
  );
}

export default Header;

function WhatsAppButton() {
  const classes = useStylesHeader();
  const contact = whatsApp.replace(/[+\s()-]/g, '');

  const redirectToWhatsApp = () => {
    const url = `https://web.whatsapp.com/send?phone=${contact}`;
    window.open(url, '_blank');
  };

  return (
    <Tooltip title='Como podemos ajudar?'>
       <IconButton size="medium" onClick={redirectToWhatsApp}>
           <WhatsAppIcon className={classes.whatsAppIcon} />
       </IconButton>
     </Tooltip>
  );
}